<template>
    <v-container class='pa-1 mt-3'>
        <h3 class="mb-3">Edit Module</h3>
        <hr class="thick" />
        <v-layout row wrap class="fill-height">
            <StepItemDialog :module="module" :step="currentModuleStep" :item="currentModuleItem"></StepItemDialog>
            <v-flex xs12>
                <v-stepper v-model="currentStep" class="f">
                    <v-stepper-header>
                        <v-stepper-step :complete="currentStep > 1" step="1">Module Details</v-stepper-step>

                        <v-divider></v-divider>

                        <v-stepper-step :complete="currentStep > 2" step="2">Module Steps</v-stepper-step>

                    </v-stepper-header>
                    <v-stepper-items class="stepper-items">

                        <v-stepper-content step="1" class="stepper-content">

                            <v-card flat class="pb-2">
                                <v-flex sm12>
                                    <v-form ref="newModuleForm" v-model="form.valid">
                                        <v-text-field label="Module Name*" :rules='form.name' v-model="module.name" required class="mt-4 pb-2 mb-2"></v-text-field>
                                        <v-text-field label="Module Title*" :rules='form.title' v-model="module.title" required class="mt-4 pb-2 mb-2"></v-text-field>
                                        <v-textarea label="Description*" :rules='form.description' placeholder="Describe your module" v-model="module.description" outline></v-textarea>
                                        <v-switch :label="`Access: ${module.public ? 'Public': 'Private' }`" v-model="module.public" color="secondary" class="mt-2 mb-0 pb-0"></v-switch>
                                        <p class='mt-2'>Add the group(s) that will have access to this module. Select the group names from the list below.</p>
                                        <v-select
                                                :items="groups"
                                                v-model="module.groups"
                                                label="Select Group(s)"
                                                item-text="name"
                                                item-value="id"
                                                multiple
                                                return-object
                                                chips
                                                hint="What are the target groups"
                                                persistent-hint
                                        ></v-select>
                                        <br>
                                        <v-btn color="primary" @click.enter="currentStep = 2" class='ml-0'>Continue</v-btn>
                                        <v-btn @click='$router.go(-1)' class="ml-1" flat outline>Cancel and Close</v-btn>
                                    </v-form>
                                </v-flex>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content step="2" class="stepper-content">
                            <v-card flat class="mb-2">
                                <v-layout>
                                    <v-flex>
                                        <v-list two-line>
                                            <draggable v-model="module.steps" class="" @start="drag=true" @end="drag=false">
                                            <v-list-group
                                              v-for="(step, stepIndex) in module.steps"
                                              :key="'mgroup-' + step.id"
                                              no-action
                                            >
                                                <v-list-tile slot="activator">
                                                    <v-list-tile-avatar color="primary" class="white--text">{{ stepIndex + 1 }}</v-list-tile-avatar>
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            {{ step.name }}
                                                        </v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                                <draggable v-model="steps[stepIndex].step_items" class="" @start="drag=true" @end="drag=false">
                                                <v-list-tile
                                                    v-for="(item, itemIndex) in step.step_items"
                                                    :key="'item-' + item.id"
                                                >
                                                    <v-list-tile-avatar color="secondary" class="white--text">{{ itemIndex + 1 }}</v-list-tile-avatar>
                                                    <v-list-tile-content>
                                                        <v-layout row align-center>
                                                        <v-flex xs11>
                                                            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                                        </v-flex>
                                                        <v-flex class="mr-0 text-xs-right">
                                                            <v-btn icon primary v-on:click.stop="dialogOpen = true" class="text-xs-right">
                                                                <v-icon>edit</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                        </v-layout>
                                                    </v-list-tile-content>
                                                </v-list-tile>

                                                </draggable>
                                            </v-list-group>
                                            </draggable>
                                        </v-list>
                                        <v-btn color="primary" @click.enter="currentStep = 1" class='ml-0'>Save</v-btn>
                                        <v-btn @click="currentStep = 1" class="ml-1">Go Back</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-stepper-content>

                    </v-stepper-items>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<style lang="scss" scoped>
    .stepper-content {
        min-height: 200px;
    }
</style>

<script>
import draggable from 'vuedraggable'
import TrainingModuleService from "@/services/TrainingModuleService"
import StepItemDialog from "./StepItemDialog"
export default {
  components: {
    draggable,
    StepItemDialog
  },
  data() {
    return {
      loading: false,
      dialogOpen: false,
      currentStep: 0,
      currentModuleStep: {},
      currentModuleItem: {},
      steps: [],
      module: {},
      form: {
        valid: false,
        //          name: [v => !!v || "A module name is required"],
        title: [v => !!v || "A module title is required"],
        description: [
          v =>
            !!v ||
            "Always a challenge, but descriptions help distinguish your module"
        ]
      }
    };
  },
  methods: {
    fetchModule(moduleId) {
      TrainingModuleService.getModule(moduleId)
        .then(res => {
          this.module = res;
          this.steps = this.module.steps;
        })
        .finally(res => {
          this.$store.commit("loading", { loading: false })
        })
    },
    saveModule() {
      if (this.$refs.newModuleForm.validate()) {
        var formData = {
          name: this.module.name,
          description: this.module.description,
          public: this.module.public,
          groups: this.module.groups
        };
        this.$http.post("modules", formData).then(
          response => {
            this.$store.commit("updateMessage", {
              message: "Module saved.",
              snackbar: true
            });
            this.$store.commit("updateModules");
            this.$router.push({ path: "/module/" + response.body.data.id });
          },
          response => {
            console.error("[module] could not save module");
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
              "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  },
  computed: {
    groups() {
      return this.$store.state.groups;
    },
    modules() {
      return this.$store.state.modules;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const user = vm.$auth.user();
      if (user.flags.length) {
        // TODO: consider checking / adding a creator id for those that can edit
        const canEdit = user.flags.filter(flag => flag.id === 1);
        if (!canEdit.length) {
          // kick non-admins back to
          next('/dashboard');
        }
      }
    });
  },
  created() {
    this.fetchModule(this.$route.params.id);
  }
};
</script>
